import { Route, Routes } from 'react-router-dom';
import AboutPage from './components/Pages/AboutPage';
import BlogPage from './components/Pages/BlogPage';
import BlogDetailsPage from './components/Pages/BlogDetailsPage';
import ContactPage from './components/Pages/ContactPage';
import ErrorPage from './components/Pages/ErrorPage';
import Home from './components/Pages/Home';
import PortfolioDetailsPage from './components/Pages/PortfolioDetailsPage';
import ServicesPage from './components/Pages/ServicesPage';
import TeamPage from './components/Pages/TeamPage';
import PortfolioPage from './components/Pages/PortfolioPage';
import TeamDetails from './components/Pages/TeamDetails';
import Layout from './components/Layout';
import FaqPage from './components/Pages/FaqPage';
import { serviceDetailsData } from './components/content/serviceDetails';
import PrivacyPolicy from './components/Pages/PrivacyPolicy';
import WhitePaper from './components/Pages/WhitePaper';
import BlogRedirect from './components/BlogRedirect'; // Import the new component

// Import your blog data - adjust the path as needed
import blogData from './components/Pages/blogs.json';

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="service" element={<ServicesPage serviceDetails={serviceDetailsData}/>} />
          <Route path="portfolio" element={<PortfolioPage />} />
          <Route
            path="portfolio/:portfolioDetailsId"
            element={<PortfolioDetailsPage />}
          />
          <Route path="blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogDetailsPage />} />
          
          {/* Add the redirect route for /rblog/f/* */}
          <Route 
            path="/rblog/f/:slug" 
            element={<BlogRedirect blogData={blogData} />} 
          />
          
          <Route path="contact" element={<ContactPage />} />
          <Route path="team" element={<TeamPage />} />
          <Route path="/team-details" element={<TeamDetails />} />
          <Route path="faq" element={<FaqPage />} />
          <Route path="privacy-policy" element={<PrivacyPolicy />} />
          <Route path="whitepaper" element={<WhitePaper />} />
        </Route>
        <Route path="*" element={<ErrorPage />} />
      </Routes>
    </>
  );
}

export default App;